import { createSlice } from '@reduxjs/toolkit'

// Course state slice - only state management, no selectors
// All selectors moved to hooks/useCourseState.js
// All utilities moved to courseUtils.js

const initialState = {
  data: {},
  status: 'idle'
};

const courseSlice = createSlice({
  name: 'course',
  initialState,
  reducers: {
    clearCourse(state) {
      state.data = {};
      state.status = 'idle';
    },
    setCourse(state, action) {
      state.data = action.payload || {};
      state.status = 'idle';
    },
  }
  // No extraReducers needed - all async operations handled by RTKQ
})

export const { clearCourse, setCourse } = courseSlice.actions;

export default courseSlice.reducer
